<template>
    <div id="hedgingMain">
        <div class="e-card">
            <div id="hedgingForm" class="row" style="padding: 2%">
                <div class="col-lg-8">
                    <div class="form-row">
                        <div class="form-group col-md-6 d-flex justify-content-center input-group">
                            <ejs-dropdownlist id="hedgingYears" ref="hedgingYears" name="hedgingYears" :dataSource='availableYears' :select="onYearSelect" :fields="{text: 'name', value: 'id' }" placeholder="Years" floatLabelType='Auto'></ejs-dropdownlist>
                        </div>
                        <div class="form-group col-md-6 d-flex justify-content-center input-group">
                            <ejs-dropdownlist id="hedgingView" ref="hedgingView" name="hedgingView" :dataSource='views' :index='firstIndex' :select="onViewSelect" :fields="{text: 'name', value: 'id' }" placeholder="View" floatLabelType='Auto'></ejs-dropdownlist>
                        </div>
                        <div class="form-group col-md-6 d-flex justify-content-center input-group">
                            <ejs-dropdownlist ref='dplCurrencyHyp' id="currencyHypTrade" name="currencyHypTrade" v-model="data.currencyId" :change="onCurrencyChangeHypTrade" :dataSource='currenciesHypTrade' :fields="{text: 'name', value: 'currencyId' }" placeholder="Currency" floatLabelType='Auto' :showClearButton='true'></ejs-dropdownlist>
                        </div>
                        <div class="form-group col-md-6 d-flex justify-content-center input-group" v-if="showPriceAreaSection">

                        </div>
                        <div class="form-group col-md-6 d-flex justify-content-center input-group" v-if="showPriceAreaSection">
                            <ejs-dropdownlist ref='dplPriceAreaHypo' id="priceAreaHypo" name="priceAreaHypoName" :change='onPriceAreaHypoChange' :actionComplete="onActionComplete" :index='firstIndex' floatLabelType='Auto' :dataSource='priceAreaHypo' :fields="{text: 'name', value: 'id' }" placeholder="Price Area:" :allowFiltering='allowFiltering' :showClearButton='true'></ejs-dropdownlist>
                        </div>
                        <div class="form-group col-md-6 d-flex justify-content-center input-group check-dh" v-if="showPriceAreaSection">

                        </div>
                    </div>
                    <div class="form-row">
                        <div class="form-group col-md-6 d-flex justify-content-center input-group">
                            <ejs-dropdownlist id="hedgingProduct" ref="hedgingProduct" name="hedgingProduct" :index='firstIndex' :dataSource='products' :dataBound="onProductSelect" :select="onProductSelect" :fields="{text: 'name', value: 'id' }" placeholder="Product" floatLabelType='Auto'></ejs-dropdownlist>
                        </div>
                        <div class="form-group col-md-6 d-flex justify-content-center input-group">
                            <div class="col-sm-2 justify-content-end">
                                <ejs-button cssClass="e-primary" v-on:click.native='download'>Hypothetical Position Report</ejs-button>
                            </div>
                        </div>
                        <div class="form-group col-md-6 d-flex justify-content-center input-group">
                            <ejs-checkbox ref="hypoCheckDM" :change="onCheckHypoDefault" label='Default Mechanism' id="HypoCheckDefault" name="checkName" floatLabelType='Auto' cssClass="hypoCheck check-d"></ejs-checkbox>
                        </div>
                    </div>
                </div>
                <div class="col-lg-4">
                </div>
            </div>
            <div id="hedgingGraph" class="row" style="max-width:100%">
                <div class="col">
                    <ejs-chart id="hypoChartContainer" ref="priceChart" :title='title' :primaryXAxis='primaryXAxis' :primaryYAxis='primaryYAxis' style="margin-top: 10px;" :palettes='palettes' :legendSettings='legendSettings' :textRender='textRender'>
                        <e-series-collection>
                            <e-series :dataSource='fixedPriceDataGraph' type='StackingColumn' xName='period' yName='value' name='Fixed' :marker="marker"></e-series>
                            <e-series :dataSource='impliedDataGraph' type='StackingColumn' xName='period' yName='value' name='Implied' :marker="marker"></e-series>
                            <e-series :dataSource='openPriceDataGraph' type='StackingColumn' xName='period' yName='value' name='Open' :marker="openMarker"></e-series>

                        </e-series-collection>
                    </ejs-chart>
                </div>
            </div>
            <div class="row">
                <div class="col m-3">
                    <ejs-grid ref="gridOpenPrice"
                              :dataSource="openGridData" id="gridOpenPrice"
                              :dataBound="dataBoundOpenPrice"></ejs-grid>
                </div>
            </div>
            <div class="row">
                <div class="col ml-3 mr-3">
                    <ejs-grid ref="gridFixedPrice"
                              :dataSource="fixedGridData" id="gridFixedPrice"
                              :dataBound="dataBoundFixedPrice"></ejs-grid>
                </div>
            </div>
            <div class="row">
                <div class="col m-3">
                    <ejs-grid ref="gridM2mPrice"
                              :dataSource="m2mGridData" id="gridM2mPrice"
                              :dataBound="dataBoundM2mPrice"></ejs-grid>
                </div>
            </div>
            <div class="row">
                <div class="col m-3">
                    <ejs-grid ref="gridImplied"
                              :dataSource="impliedGridData" id="gridImplied"
                              :dataBound="dataBoundImplied"></ejs-grid>
                </div>
            </div>
        </div>
        <div style="margin-top: 10px;">
            <ejs-button id='btnAddWhatIf' ref='btnAddWhatIf' :isPrimary="true" v-on:click.native="modalBtnClick">Add 'What If?' Position</ejs-button>
            <ejs-button id='btnClearWhatIf' v-on:click.native="clearWhatIf" style="margin-left: 10px;">Clear 'What If?' Position</ejs-button>
        </div>
        <div id="hedgingSpinner"></div>
    </div>
</template>

<script>
    import Vue from "vue";
    import { GridPlugin, Grid } from "@syncfusion/ej2-vue-grids";
    import { ButtonPlugin } from "@syncfusion/ej2-vue-buttons";
    import { DialogPlugin, DialogUtility } from '@syncfusion/ej2-vue-popups';
    import { TextBoxPlugin } from "@syncfusion/ej2-vue-inputs";
    import apis from '../../../common/network'
    import store from '../../../store';
    import urls from '../../../common/urls';
    import SyncHelper from '../../../common/syncfusion';
    import { createSpinner, showSpinner, hideSpinner } from '@syncfusion/ej2-popups';
    import { ChartPlugin, StackingColumnSeries, Category, DataLabel, Legend } from "@syncfusion/ej2-vue-charts";

    import gridOptions from '../../../common/gridOptions'

    Vue.use(ButtonPlugin);
    Vue.use(DialogPlugin);
    Vue.use(TextBoxPlugin);
    Vue.use(GridPlugin);
    Vue.use(DialogPlugin);
    Vue.use(ChartPlugin);

    export default {
        name: 'HedgingOverviewReport',
        created() {
        },
        data() {
            return {
                data: {},
                palettes: ["#485696", "#a35ea1", "#dadada"],
                openGridData: [],
                fixedGridData: [],
                m2mGridData: [],
                impliedGridData: [],
                firstIndex: 0,
                unit: null,
                currencyHypTrade: null,
                currencyId: null,
                value: null,
                fixedPriceDataGraph: [],
                openPriceDataGraph: [],
                impliedDataGraph: [],
                openPriceGrid: null,
                fixedPriceGrid: null,
                m2mPriceGrid: null,
                triggeredFixedPrice: false,
                triggeredOpenPrice: false,
                triggeredM2mPrice: false,
                triggeredImplied: false,
                showPriceAreaSection: false,
                priceAreaNames: store.state.pricingAreaNames,
                openPeriods: [],
                firstIndexCurrency: 3,
                fixedPeriods: [],
                openPriceData: [],
                fixedPriceData: [],
                availableYears: [],
                openMarker: {
                    dataLabel: {
                        visible: true,
                        font: { fontFamily: 'Segoe UI', fontStyle: 'normal', fontSize: '13px', fontWeight: 'normal', textAnchor: 'middle' }, position: 'Middle'
                    }
                },
                marker: {
                    dataLabel: {
                        visible: true,
                        font: { fontFamily: 'Segoe UI', fontStyle: 'normal', fontSize: '13px', fontWeight: 'normal', textAnchor: 'middle' }, position: 'Middle'
                    }
                },
                legendSettings: {
                    visible: true,
                    position: 'Bottom',
                    textStyle: { fontFamily: 'Segoe UI', fontStyle: 'normal', fontSize: '13px', fontWeight: 'normal', textAnchor: 'middle', color: '#8a93a2' }
                },
                primaryXAxis: {
                    valueType: 'Category',
                    title: ' ',
                    labelStyle: { fontFamily: 'Segoe UI', fontStyle: 'normal', fontSize: '14px', fontWeight: 'normal', textAnchor: 'middle', color: '#8a93a2' }
                },
                primaryYAxis:
                {
                    //minimum: 0,
                    //maximum: 100,
                    //interval: 20,
                    title: 'Volume',
                    labelFormat: 'n1',
                    titleStyle: { fontFamily: 'Segoe UI', fontStyle: 'normal', fontSize: '14px', fontWeight: 'normal', textAnchor: 'middle', color: '#8a93a2' },
                    labelStyle: { fontFamily: 'Segoe UI', fontStyle: 'normal', fontSize: '14px', fontWeight: 'normal', textAnchor: 'middle', color: '#8a93a2' },
                },
                years: null,
                title: "Hedging Overview",
                views: [{ "name": "100% Stacked", "id": 1 }, { "name": "Stacked", "id": 2 }, { "name": "Cost", "id": 3 }],

                isModalVisible: false,
                isModal: true,
                target: "#mainHypothetical",
                header: 'What if?',
                width: '1300px',
                animationSettings: { effect: 'None' },
                allowFiltering: true

            }
        },
        mounted() {
            if (this.$route.params.navigateFrom != "trade") {
                apis.protectedApi.delete(`hypoTrade`);
            }
            createSpinner({
                target: document.getElementById('hedgingSpinner')
            });
            createSpinner({
                target: document.getElementById('mainSpinner'),
                width: '50',
                type: 'Material',
                label: 'Loading data...',
                cssClass: 'loading'
            });
            showSpinner(document.getElementById("mainSpinner"));
            document.getElementById('btnAddWhatIf').focus();
        },
        methods: {
            onActionComplete(args) { //initial load to be set on the first pricing area
                let currencyId = this.$refs.currencyHypTrade.ej2Instances.value;
                if (args.result && args.result.length > 0) {
                    this.getHedgingHypoData(this.$refs.hedgingProduct.ej2Instances.text, this.$refs.hedgingYears.ej2Instances.text, this.$refs.hedgingView.ej2Instances.text, currencyId, args.result[0].id, false);
                    this.getHedgingData(this.$refs.hedgingProduct.ej2Instances.text, this.$refs.hedgingYears.ej2Instances.text, this.$refs.hedgingView.ej2Instances.text, currencyId, args.result[0].id, false);
                }
            },
            onPriceAreaHypoChange: function (args) {
                if (args.isInteracted) {
                    let currencyId = this.$refs.currencyHypTrade.ej2Instances.value;
                    
                    this.getHedgingHypoData(this.$refs.hedgingProduct.ej2Instances.text, this.$refs.hedgingYears.ej2Instances.text, this.$refs.hedgingView.ej2Instances.text, currencyId, args.itemData == null ? null : args.itemData.id, false);
                    this.getHedgingData(this.$refs.hedgingProduct.ej2Instances.text, this.$refs.hedgingYears.ej2Instances.text, this.$refs.hedgingView.ej2Instances.text, currencyId, args.itemData == null ? null : args.itemData.id, false);
                                       
                }
            },
            onCheckPASystemHypo(args) {
                let pricingAreaId = document.getElementById('priceAreaHypo') == null ? undefined : document.getElementById('priceAreaHypo').ej2_instances[0].value;
                let currencyId = this.$refs.currencyHypTrade.ej2Instances.value;
              
                this.getHedgingHypoData(this.$refs.hedgingProduct.ej2Instances.text, this.$refs.hedgingYears.ej2Instances.text, this.$refs.hedgingView.ej2Instances.text, currencyId, pricingAreaId, false);
                this.getHedgingData(this.$refs.hedgingProduct.ej2Instances.text, this.$refs.hedgingYears.ej2Instances.text, this.$refs.hedgingView.ej2Instances.text, currencyId, pricingAreaId, false);
                

            },
            textRender: function (args) {
                if (args.text == '0.0' || args.text == '0.00') {
                    args.text = '';
                }
            },
            calculateYears: function (startDate, endDate) {
                this.availableYears = [];
                var startYearMonth = new Date(startDate).getMonth();
                var endYearMonth = new Date(endDate).getMonth();
                var min = new Date(startDate).getFullYear();
                var max = new Date(endDate).getFullYear();
                if (endYearMonth < startYearMonth) {
                    max = max - 1;
                }
                var j = 1;

                for (var i = min; i <= max; i++) {
                    var nextyear = i + 1;
                    var yearName = startYearMonth == 0 ? ("Y" + j + "-" + i) : ("Y" + j + "-" + i + "/" + nextyear);
                    this.availableYears.push({ "name": yearName, "id": j })
                    j++;
                }
                this.$ref.hedgingYears.ej2Instances.value = 1;
            },
            onCheckHypoDefault(args) {
                let pricingAreaId = document.getElementById('priceAreaHypo') == null ? undefined : document.getElementById('priceAreaHypo').ej2_instances[0].value;
                store.state.isCheckDefaultM = args.checked;
                var checkArea = false;
                
                this.getHedgingHypoData(this.$refs.hedgingProduct.ej2Instances.text, this.$refs.hedgingYears.ej2Instances.text, this.$refs.hedgingView.ej2Instances.text, pricingAreaId, checkArea);
                this.getHedgingData(this.$refs.hedgingProduct.ej2Instances.text, this.$refs.hedgingYears.ej2Instances.text, this.$refs.hedgingView.ej2Instances.text, pricingAreaId, checkArea);
            },
            onViewSelect: function (args) {
                let pricingAreaId = document.getElementById('priceAreaHypo') == null ? undefined : document.getElementById('priceAreaHypo').ej2_instances[0].value;
                let currencyRef = this.$refs.currencyHypTrade;
                let currencyId = currencyRef ? currencyRef.ej2_instances[0].value : undefined;
                var checkArea = false;
               
                this.getHedgingHypoData(this.$refs.hedgingProduct.ej2Instances.text, this.$refs.hedgingYears.ej2Instances.text, args.itemData.name, currencyId, pricingAreaId, checkArea);

                this.getHedgingData(this.$refs.hedgingProduct.ej2Instances.text, this.$refs.hedgingYears.ej2Instances.text, args.itemData.name, currencyId, pricingAreaId, checkArea);
            },
            onProductSelect: function (args) {
                let pricingAreaId = document.getElementById('priceAreaHypo') == null ? undefined : document.getElementById('priceAreaHypo').ej2_instances[0].value;
                var prodName = args.itemData == null ? this.$refs.hedgingProduct.ej2Instances.text : args.itemData.name;

                let currencyRef = this.$refs.currencyHypTrade;
                let currencyId = currencyRef ? currencyRef.ej2_instances[0].value : undefined;

                var checkArea = false;
               
                this.getHedgingHypoData(prodName, this.$refs.hedgingYears.ej2Instances.text, this.$refs.hedgingView.ej2Instances.text, currencyId, pricingAreaId, checkArea);

                this.getHedgingData(prodName, this.$refs.hedgingYears.ej2Instances.text, this.$refs.hedgingView.ej2Instances.text, currencyId, pricingAreaId, checkArea);
            },
            onYearSelect: function (args) {
                var checkArea = false;
               
                let pricingAreaId = document.getElementById('priceAreaHypo') == null ? undefined : document.getElementById('priceAreaHypo').ej2_instances[0].value;
                this.getHedgingHypoData(this.$refs.hedgingProduct.ej2Instances.text, args.itemData.name, this.$refs.hedgingView.ej2Instances.text, pricingAreaId, checkArea);
                let currencyRef = this.$refs.currencyHypTrade;
                let currencyId = currencyRef ? currencyRef.ej2_instances[0].value : undefined;
                this.getHedgingData(this.$refs.hedgingProduct.ej2Instances.text, args.itemData.name, this.$refs.hedgingView.ej2Instances.text, currencyId, pricingAreaId, checkArea);
            },
            onCurrencyChangeHypTrade: function (args) {

                let pricingAreaId = document.getElementById('priceAreaHypo') == null ? undefined : document.getElementById('priceAreaHypo').ej2_instances[0].value;
                let currencyId = args?.itemData?.currencyId;
                var checkArea = false;
              
                this.getHedgingHypoData(this.$refs.hedgingProduct.ej2Instances.text, this.$refs.hedgingYears.ej2Instances.text, this.$refs.hedgingView.ej2Instances.text, currencyId, pricingAreaId, checkArea);
                this.getHedgingData(this.$refs.hedgingProduct.ej2Instances.text, this.$refs.hedgingYears.ej2Instances.text, this.$refs.hedgingView.ej2Instances.text, currencyId, pricingAreaId, checkArea);
            },
            getHedgingData: function (product, year, view, currencyId, pricingAreaId, pricingAreaSystem) {

                showSpinner(document.getElementById('hedgingSpinner'));
                showSpinner(document.getElementById('mainSpinner'));
                apis.protectedApi(`utils/atgTradeablePeriods?atgId=${store.state.reportTradingGroupId}`).then(ctpResponse => {
                    this.allTradePeriods = ctpResponse.data;
                }).catch(e => {
                    if (e.response.data.message) {
                        this.showErrorDialog(e.response.data.message);
                    }
                });

                apis.protectedApi(`report/hedgingOverviewATG/${store.state.reportTradingGroupId}?product=${product}&year=${year}&view=${view}&currencyId=${currencyId == undefined ? "" : currencyId}
                &defaultM=${store.state.isCheckDefaultM == undefined ? "" : store.state.isCheckDefaultM}&pricingAreaId=${pricingAreaId == undefined ? "" : pricingAreaId}&pricingAreaSystem=${pricingAreaSystem == undefined ? false : pricingAreaSystem}`)
                    .then(response => {
                        this.data = response.data.data;
                        this.value = response.data.value;
                        this.unit = response.data.unit;
                        this.currency = response.data.currency;
                        this.currencyId = response.data.currencyId;
                        this.bindGrids(view);                                          
                        this.calculateYears(response.data.startDate, response.data.endDate);

                        hideSpinner(document.getElementById('hedgingSpinner'));
                        hideSpinner(document.getElementById('mainSpinner'));
                    }).catch(e => {
                        hideSpinner(document.getElementById('hedgingSpinner'));
                        hideSpinner(document.getElementById('mainSpinner'));
                        if (e.response) {
                            this.showErrorDialog(e.response.data.message);
                        }
                    })
            },
            getHedgingHypoData: function (product, year, view, currencyId, pricingAreaId, pricingAreaSystem) {

                showSpinner(document.getElementById('hedgingSpinner'));
                showSpinner(document.getElementById('mainSpinner'));
                apis.protectedApi(`report/hedgingHypotheticalOverviewATG/${store.state.reportTradingGroupId}?product=${product}&year=${year}&view=${view}&currencyId=${currencyId == undefined ? "" : currencyId}
                &defaultM=${store.state.isCheckDefaultM == undefined ? "" : store.state.isCheckDefaultM}&pricingAreaId=${pricingAreaId == undefined ? "" : pricingAreaId}&pricingAreaSystem=${pricingAreaSystem == undefined ? false : pricingAreaSystem}`)
                    .then(response => {
                        this.bindImpliedGrid(response.data.data);

                        if (response.data.value == 'p/therm') {

                            this.$refs.dplCurrencyHyp.ej2Instances.text = "p - GBp";

                        } else {

                            this.$refs.dplCurrencyHyp.ej2Instances.text = response.data.currencySymbolAndName;
                        }
                        hideSpinner(document.getElementById('hedgingSpinner'));
                        hideSpinner(document.getElementById('mainSpinner'));
                    }).catch(e => {
                        hideSpinner(document.getElementById('hedgingSpinner'));
                        hideSpinner(document.getElementById('mainSpinner'));
                        if (e.response) {
                            this.showErrorDialog(e.response.data.message);
                        }
                    })
            },
            download: function (args) {
                showSpinner(document.getElementById('hedgingSpinner'));
                showSpinner(document.getElementById("mainSpinner"));
                let currencyRef = this.$refs.currencyHypTrade;
                let currencyId = currencyRef ? currencyRef.ej2_instances[0].value : undefined;
                
                apis.protectedApi(`${urls.apiBaseUrl}ReportTemplate/generateHypotheticalReportPageATG/${store.state.reportTradingGroupId}?currencyId=${currencyId == undefined ? "" : currencyId}&defaultM=${this.$refs.hypoCheckDM.ej2Instances.checked}`).then(it => {
                    window.open(it.data.reportUri);
                    hideSpinner(document.getElementById('hedgingSpinner'));
                    hideSpinner(document.getElementById('mainSpinner'));
                }
                ).catch(
                    response => {
                        var message = response.response.data.message != undefined ? response.response.data.message : "Error invoking service,please contact support";
                        gridOptions.errorAlert("Error: " + message);
                        hideSpinner(document.getElementById('hedgingSpinner'));
                        hideSpinner(document.getElementById('mainSpinner'));
                    }
                );
            },
            bindGrids: function (view) {

                this.openGridData = this.data.open;
                this.fixedGridData = this.data.fixed;
                this.m2mGridData = this.data.m2m;

                this.fixedPriceDataGraph = [];
                for (const property in this.data.fixed[1]) {
                    var s = {
                        period: property,
                        value: this.data.fixed[1][property].replaceAll(",", "")
                    };
                    if (property != "Fixed") {
                        this.fixedPriceDataGraph.push(s);
                    }
                }

                var chart = document.getElementById('hypoChartContainer').ej2_instances[0];
                if (view == "100% Stacked") {
                    chart.primaryYAxis =
                    {
                        title: 'Volume %',
                        labelFormat: 'N1'
                    }
                }
                else if (view == "Stacked") {
                    chart.primaryYAxis =
                    {
                        title: 'Volume ' + this.unit,
                        labelFormat: 'N2'
                    }

                }
                if (view == "Cost") {//cost
                    chart.primaryYAxis =
                    {
                        title: 'Cost ' + this.currency,
                        labelFormat: 'N0'
                    }
                    this.openMarker = {
                        dataLabel: {
                            visible: true,
                        }
                    }
                }
                chart.refresh();
                this.triggeredOpenPrice = false;
                this.triggeredFixedPrice = false;
                this.triggeredM2mPrice = false;
                setTimeout(function (e) {
                    e.refresh();
                }, 0, this.$refs.gridOpenPrice);

                setTimeout(function (e) { e.refresh(); }, 50, this.$refs.gridFixedPrice);
                setTimeout(function (e) {
                    e.refresh();
                }, 150, this.$refs.gridM2mPrice);
            },
            bindImpliedGrid: function (data) {

                this.impliedGridData = data;

                this.impliedDataGraph = [];
                for (const property in data[3]) {
                    var s = {
                        period: property,
                        value: data[3][property].replaceAll(",", "")
                    };
                    if (property != "Implied") {
                        this.impliedDataGraph.push(s);
                    }
                }
                this.openPriceDataGraph = [];
                for (const property in data[7]) {
                    var s = {
                        period: property,
                        value: data[7][property].replaceAll(",", "")
                    };
                    if (property != "Implied") {
                        this.openPriceDataGraph.push(s);
                    }
                }

                var chart = document.getElementById('hypoChartContainer').ej2_instances[0];
                chart.refresh();

                this.triggeredImplied = false;
                this.$refs.gridImplied.refresh();
            },
            dataBoundImplied: function () {
                if (this.triggeredImplied == false) {
                    this.dataBound(this.$refs.gridImplied);
                }
                this.triggeredImplied = true;
            },
            dataBoundOpenPrice: function () {
                if (this.triggeredOpenPrice == false) {
                    this.dataBound(this.$refs.gridOpenPrice);
                }
                this.triggeredOpenPrice = true;
            },
            dataBoundFixedPrice: function () {
                if (this.triggeredFixedPrice == false) {
                    this.dataBound(this.$refs.gridFixedPrice);
                }
                this.triggeredFixedPrice = true;
            },
            dataBoundM2mPrice: function () {
                if (this.triggeredM2mPrice == false) {
                    this.dataBound(this.$refs.gridM2mPrice);
                }
                this.triggeredM2mPrice = true;
            },
            dataBound: function (grid) {
                var cols = Object.keys(grid.getCurrentViewRecords()[0]);
                var length = cols.length;
                var col = [];
                for (var i = 0; i < length; i++) {
                    var field = cols[i];
                    var obj = {};

                    obj["field"] = field;
                    if (field == "Open" || field == "Fixed" || field == "M2M") {
                        obj["width"] = 190;
                    } else if (field == "Implied") {
                        obj["width"] = 220;
                        obj["headerText"] = "Implied Position"
                    } else {
                        obj["width"] = 120;
                    }
                    col.push(obj);
                }
                grid.setProperties({ columns: col });
            },
            showErrorDialog: function (message) {
                DialogUtility.alert({
                    title: 'Alert Dialog',
                    content: message,
                    position: { X: 700, Y: 200 },
                    showCloseIcon: true,
                    closeOnEscape: true,
                    animationSettings: { effect: 'Zoom' }
                });
            },
            modalBtnClick: function () {

                this.$router.push({ name: "Trade", params: { callerId: store.state.reportTradingGroupId, callerForm: "ATGReports", callerTab: "hypothetical" } });
            },
            clearWhatIf: function () {
                apis.protectedApi.delete(`hypoTrade`).then(response => {
                    this.getHedgingHypoData(this.$refs.hedgingProduct.ej2Instances.text, this.$refs.hedgingYears.ej2Instances.text, this.$refs.hedgingView.ej2Instances.text);
                }).catch(e => {
                    this.showErrorDialog(e.response.data.message);
                });
            },
        },
        computed: {
            products() {
                return SyncHelper.getDataManager("utils/products?tradingGropuId=" + store.state.reportTradingGroupId + "&includeCombined=true");
            },
            currenciesHypTrade() {
                return SyncHelper.getDataManager("utils/currenciesAvailable?tradingGroupId=" + store.state.reportTradingGroupId);
            },
            priceAreaHypo() {
                return SyncHelper.getDataManager("utils/pricingContractAreas?tradingGroupId=" + store.state.reportTradingGroupId);
            }
        },
        provide: {
            chart: [StackingColumnSeries, Category, DataLabel, Legend]
        },
        updated: function () {
            this.$nextTick(() => {
                window.dispatchEvent(new Event('resize'));
            });
        },
    }

</script>

<style>
    #hypoChartContainer_ChartTitle {
/*        font-family: "Segoe UI";*/
        font-style: normal;
        font-size: 15px;
        font-weight: 500;
        text-anchor: middle;
        fill: #8a93a2;
    }

    .hypoCheck {
        padding: 1em 24em 0em 0em;
    }
    #hedgingSpinner {
        display: none;
    }
</style>